import {Component} from '@angular/core';
import {NotificationService} from "../../utils/notification.service";
import {NeoGlobalService} from "ng-neo";

declare var $: any;

@Component({
    selector: 'sa-logout',
    template: `
        <div id="logout" (click)="showPopup()" class="btn-header transparent pull-right">
        <span> <a routerlink="/auth/login" title="Sign Out" data-action="userLogout"
                  data-logout-msg="You can improve your security further after logging out by closing this opened browser"><i
                class="fa fa-sign-out"></i></a> </span>
        </div>
    `,
    styles: []
})
export class LogoutComponent {

    constructor(private _gs: NeoGlobalService,
                private notificationService: NotificationService) {
    }

    showPopup() {
        this.notificationService.smartMessageBox({
            title: "<i class='fa fa-sign-out txt-color-orangeDark'></i> Logout <span class='txt-color-orangeDark'><strong>" + $('#show-shortcut').text() + "</strong></span> ?",
            content: "You can improve your security further after logging out by closing this opened browser",
            buttons: '[No][Yes]'

        }, (ButtonPressed) => {
            if (ButtonPressed == "Yes") {
                this.logout()
            }
        });
    }

    logout() {
        this._gs.set('isLogin', false);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/user/logout/logout.component.ts